import { ImportExport } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";

// 2 saidas: 'a' = SIM (verde, em cima), 'b' = NAO (vermelho, em baixo).
// Labels visiveis pro admin saber qual e qual ao conectar arestas.
export default memo(({ data, isConnectable }) => {
  const typeCondition = (value) => {
    if (value === 1) return "==";
    if (value === 2) return ">=";
    if (value === 3) return "<=";
    if (value === 4) return "<";
    if (value === 5) return ">";
    return "?";
  };
  return (
    <div style={{ backgroundColor: "#555", padding: "8px 24px 8px 8px", borderRadius: "8px", minWidth: 180, position: "relative" }}>
      <Handle
        type="target"
        position="left"
        style={{ background: "#9a00ed" }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      <div style={{ color: "#ededed", fontSize: "16px", flexDirection: "row", display: "flex" }}>
        <ImportExport sx={{ width: "16px", height: "16px", marginRight: "4px", marginTop: "4px" }} />
        <div style={{ color: "#ededed", fontSize: "16px" }}>Condição</div>
      </div>
      <div style={{ color: "#ededed", fontSize: "12px" }}>{data.key}</div>
      <div style={{ color: "#ededed", fontSize: "12px" }}>{typeCondition(data.condition)}</div>
      <div style={{ color: "#ededed", fontSize: "12px" }}>{data.value}</div>

      {/* Saida SIM — verde, topo */}
      <span style={{ position: "absolute", right: 14, top: 4, color: "#4caf50", fontSize: 10, fontWeight: 700 }}>SIM</span>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{ top: 16, background: "#4caf50", width: 12, height: 12, border: "2px solid #2e7d32" }}
        isConnectable={isConnectable}
      />

      {/* Saida NAO — vermelho, base */}
      <span style={{ position: "absolute", right: 14, bottom: 4, color: "#ef5350", fontSize: 10, fontWeight: 700 }}>NÃO</span>
      <Handle
        type="source"
        position="right"
        id="b"
        style={{ bottom: 16, top: "auto", background: "#ef5350", width: 12, height: 12, border: "2px solid #c62828" }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
